import { render } from "./loginView.vue?vue&type=template&id=1975f50a&scoped=true"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"

import "./loginView.vue?vue&type=style&index=0&id=1975f50a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1975f50a"]])

export default __exports__